import React from "react";
import { Link } from "react-router-dom";

export default function ThankYou() {
  return (
    <div className="min-h-[65vh] flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 via-blue-100 to-white px-4">
      {/* Animated Tick Mark */}
      <svg
        className="w-32 h-32 mb-6"
        viewBox="0 0 120 120"
        fill="none"
      >
        {/* Outer Circle */}
        <circle
          cx="60"
          cy="60"
          r="50"
          stroke="#2563eb"
          strokeWidth="8"
          fill="#fff"
          opacity="0.12"
        />
        {/* Animated Tick Path */}
        <path
          d="M40 65 L55 80 L82 50"
          stroke="#2563eb"
          strokeWidth="8"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        >
          <animate
            attributeName="stroke-dasharray"
            from="0,60"
            to="60,0"
            dur="0.8s"
            fill="freeze"
          />
        </path>
      </svg>
      <h1 className="text-4xl font-extrabold text-blue-900 mb-2 drop-shadow">Thank You!</h1>
      <p className="text-xl sm:text-2xl text-gray-700 text-center max-w-xl mb-6">
        Your message has been submitted.<br />
        We appreciate your interest.
        Our team will get in touch with you soon.
      </p>
      <Link
        to="/"
        className="inline-block bg-blue-900 text-white px-7 py-3 rounded-lg font-semibold hover:bg-blue-800 shadow transition"
      >
        Back to Home
      </Link>
    </div>
  );
}
